import React from 'react';

interface ServiceBlogProps {
    title: string;
    icon: React.ReactNode;
    description?: string;
    onClick?: () => void;
}

const ServiceBlog2: React.FC<ServiceBlogProps> = (props) => {
    return (
        <div
            className="service-box"
            onClick={props.onClick}
            role={props.onClick ? 'button' : undefined}
            tabIndex={props.onClick ? 0 : undefined}
            onKeyDown={(e) => {
                if (props.onClick && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault();
                    props.onClick();
                }
            }}
        >
            <div className="service-icon">
                {props.icon}
            </div>
            <div className="service-box-text">
                <h3 className="h3-title">{props.title}</h3>
                {props.description && <p>{props.description}</p>}
            </div>
            {props.onClick && <span className="service-box-cta">Learn more &rarr;</span>}
        </div>
    );
};

export { ServiceBlog2 };
export default ServiceBlog2;